import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchTotalAnalytics } from '@/store/Admin';
import { TotalAnalytics } from '../constants/types';

export const useTotalAnalytics = () => {
  const dispatch = useDispatch<any>();
  const [totalAnalytics, setTotalAnalytics] = useState<TotalAnalytics>();

  useEffect(() => {
    const fetchData = async () => {
      const res = await dispatch(fetchTotalAnalytics());
      setTotalAnalytics(res.payload.data[0]);
    };
    fetchData();
  }, [dispatch]);

  return totalAnalytics;
};
